<template>
    <div>
        <Header></Header>
        <div class='contents'>
            <Sidebar/>
            <router-view/>
        </div>
    </div>
</template>

<script>

import Header from '@/components/admin/Header.vue'
import Sidebar from '@/components/admin/Sidebar.vue'

export default {
    name: 'Admin',
    components: {
        Header,
        Sidebar
    },
    data () {
        return {
        }
    },
    mounted () {
        const self = this
        self.axios.post(`${process.env.API_URL}/sessionCheck`).then((res) => {
            if (res.data.type !== 'admin') {
                throw new Error()
            }
            self.type = res.data.type
        }).catch((e) => {
            alert('アクセス権限が無いかサーバーに問題が発生しています')
            self.$router.push('/login')
        })
    },
    methods: {
    }
}
</script>

<style scoped>

.contents {
    display: flex;
}

.main {
    padding-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/routes/Admin.vue